"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTicketLatestStatus = void 0;
var ProductTicketLatestStatus;
(function (ProductTicketLatestStatus) {
    ProductTicketLatestStatus["Active"] = "active";
    ProductTicketLatestStatus["ReminderSent"] = "reminderSent";
    ProductTicketLatestStatus["ReminderOpened"] = "reminderOpened";
    ProductTicketLatestStatus["Canceled"] = "canceled";
    ProductTicketLatestStatus["CheckedIn"] = "checked-in";
})(ProductTicketLatestStatus || (exports.ProductTicketLatestStatus = ProductTicketLatestStatus = {}));
